export const buildPTProductTypeLink = (
  productCategory: string,
  productType: string,
  normalizedBrand?: string,
) => {
  if (productCategory === productType) {
    if (productCategory === 'clothing') {
      return `/apparel`;
    }
    return `/${productType}`;
  }

  if (productCategory === 'clothing') {
    return `/apparel/${productType}`;
  }

  if (productCategory === 'accessories' && productType === 'jewelry') {
    return `/${productType}`;
  }

  if (normalizedBrand) {
    return `/${productCategory}/brand/${normalizedBrand}/${productType}`;
  }

  return `/${productCategory}/${productType}`;
};
